import styled from "@emotion/styled";
import {
  Box,
  Button,
  Container,
  FormControl,
  FormGroup,
  InputBase,
  InputLabel,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { cancelIcon } from "../../../assets";
import { tokens } from "../../../theme";

const StyledInput = styled(InputBase)(
  ({ theme, width, height, fontSize, textAlign }) => ({
    border: "1px solid #E8ECF5",
    borderRadius: "6px",
    background: "#F9F8FD",
    height: height ? height : "53px",
    width: width ? width : "736px",
    padding: "20px",
    fontSize: fontSize ? fontSize : "24px",
    fontWeight: 500,
    color: "#343744",
    "& input": {
      textAlign,
    },
  })
);
const CrossBox = styled(Box)({
  width: "31px",
  height: "31px",
  borderRadius: "31px",
  border: "0.5px solid #6A27EA",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  right: "40px",
  cursor: "pointer",
});

const Header = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  borderBottom: "1px solid #E8ECF5",
  width: "100%",
  height: "88px",
  marginBottom: "20px",
  position: "relative",
});

const StyledFormControl = styled(FormControl)({
  borderBottom: "1px solid #E8ECF5",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  height: "68px",
  paddingLeft: "10px",
});

const SplitRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  paddingLeft: "10px",
  marginTop: "9px",
});

const SplitBox = styled(FormControl)({
  width: "49%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #E8ECF5",
  borderRadius: "6px",
  backgroundColor: "#ffffff",
});

const StyledButton = styled(Button)(({ theme, colors }) => ({
  width: "100%",
  height: "55px",
  //   border: `1px solid ${colors.primary[500]}`,
  color: colors.whiteAccent[900],
  backgroundColor: colors.primary[500],
  borderRadius: "7px",
  fontSize: "12px",
  fontWeight: 400,
  marginTop: "30px",
  "&:hover": {
    color: colors.primary[500],
    backgroundColor: colors.whiteAccent[900],
    border: `1px solid ${colors.primary[500]}`,
  },
}));

export const AddScholarForm = ({ onClose, formik }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isBackeSpacePressed, setIsBackeSpacePressed] = useState(false);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
      }}
    >
      <Header>
        <Typography variant="h2" color={colors.black[500]} fontWeight={500}>
          Add Scholar
        </Typography>
        <CrossBox onClick={() => onClose()}>
          <img src={cancelIcon} alt="cross" />
        </CrossBox>
      </Header>
      <FormGroup sx={{ width: "90%" }}>
        <StyledFormControl>
          <Typography
            variant="caption"
            color={colors.black[500]}
            fontWeight={500}
          >
            Name
          </Typography>
          <StyledInput
            placeholder="Name Here"
            id="scholarName"
            name="scholarName"
            value={formik.values.scholarName}
            onChange={(e) => {
              if (e.target.value.length > 50) return;
              formik.handleChange(e);
            }}
          />
        </StyledFormControl>

        <StyledFormControl>
          <Typography
            variant="caption"
            color={colors.black[500]}
            fontWeight={500}
          >
            Address
          </Typography>
          <StyledInput
            placeholder="Enter Address"
            id="scholarAddress"
            name="scholarAddress"
            value={formik.values.scholarAddress}
            onChange={(e) => {
              if (e.target.value.length > 50) return;
              formik.handleChange(e);
            }}
          />
        </StyledFormControl>

        {/* <SplitRow>
          <Typography
            variant="caption"
            color={colors.black[500]}
            fontWeight={500}
          >
            Split Earnings
          </Typography>
          <Stack
            direction="row"
            sx={{ width: "736px", justifyContent: "space-between" }}
          >
            <SplitBox>
              <Typography
                variant="overline"
                color={colors.black[500]}
                fontWeight={400}
              >
                Guild
              </Typography>
              <StyledInput
                placeholder="%"
                id="guildSplit"
                name="guildSplit"
                width="100%"
                height="38px"
                fontSize="18px"
                textAlign="center"
                value={formik.values.guildSplit}
                onChange={(e) => {
                  const reg = /^[0-9\b]+$/;
                  const test = reg.test(e.currentTarget.value);

                  if (!test && !isBackeSpacePressed) {
                    return;
                  }

                  if (e.currentTarget.value.length > 2) return;

                  formik.handleChange(e);
                }}
                onKeyDown={(event) => {
                  if (event.keyCode === 8) {
                    setIsBackeSpacePressed(true);
                  } else {
                    setIsBackeSpacePressed(false);
                  }
                }}
              />
            </SplitBox>
            <SplitBox>
              <Typography
                variant="overline"
                color={colors.black[500]}
                fontWeight={400}
              >
                Scholar
              </Typography>
              <StyledInput
                placeholder="%"
                id="scholarSplit"
                name="scholarSplit"
                width="100%"
                height="38px"
                fontSize="18px"
                textAlign="center"
                value={
                  formik.values.guildSplit
                    ? 100 - Number(formik.values.guildSplit)
                    : ""
                }
              />
            </SplitBox>
          </Stack>
        </SplitRow> */}

        <StyledButton
          onClick={() => {
            formik.handleSubmit();
          }}
          variant={"contained"}
          colors={colors}
          disabled={!formik.values.scholarName || !formik.values.scholarAddress}
        >
          Save
        </StyledButton>
      </FormGroup>
    </Box>
  );
};
